<template>
	<div class="confirm-size-wrapper">
		<VeeForm :validation-schema="confirmValidationSchema" v-slot="{ handleSubmit, errors }" as="div">
			<form class="row confirm-size-form" @submit="handleSubmit($event, onSizeSubmit)" method="post">
				<div class="col-12 col-md-4 mb-2 mb-sm-4">
					<div class="border-thin rounded-lg p-3">
						<h1 class="h3 text-start fs-5">Confirm your car details</h1>
						<p class="d-inline-block me-2">Registration: </p>
						<div class="reg-input">
							<span>{{ car.registration }}</span>
						</div>
						<div class="d-inline-block cursor-pointer" @click="toggleRegSizeForm()">
							<i class="fa-solid fa-pen-to-square ms-3 ms-md-0 ms-xl-3 me-2 cursor-pointer"></i>
							<p class="d-inline-block mb-1 text-underline">Change vehicle</p>
						</div>
						<p class="d-inline-block me-2">Model:</p>
						<b class="d-inline-block">{{ car.make }} {{ car.derivative }} - {{ car.colour }}</b>
						<div class="run-flat-check mt-2 mb-md-3 mb-0 d-flex flex-column flex-sm-row flex-md-column flex-xl-row justify-content-between" v-if="car.make != null && runFlatCheckMakes.includes(car.make.toLowerCase())">
							<div>
								<b class="d-block mb-1">Do you currently have<br class="d-none d-md-block"> run flat tyres fitted?</b>
								<a :href="this.baseUrl + '/run-flat-tyres'" class="text-underline text-secondary fs-6" target="_blank">How to check..</a>
								<div class="run-flat-select mt-2">
									<ul class="p-0 mb-0">
										<li class="d-inline-block me-2">
											<Field name="run_flat" id="rf_yes" type="radio" class="btn-check" :value="1" :checked="(runFlatLanding == true ? 'checked' : '')"/>
											<label class="btn btn-outline-secondary size-label" for="rf_yes">Yes</label>
										</li>
										<li class="d-inline-block">
											<Field name="run_flat" id="rf_no" type="radio" class="btn-check" :value="0" />
											<label class="btn btn-outline-secondary size-label" for="rf_no">No</label>
										</li>
									</ul>
								</div>
							</div>
							<img class="mt-2 mt-sm-0 mt-md-2 mt-lg-0 ms-3 d-none d-xl-block" :src="this.baseUrl + '/assets/img/generic_images/run_flat_check.png'" alt="Run Flat Check" />
						</div>
						<Field v-else name="run_flat" type="hidden" :value="runFlat == true ? 1 : 0" />
						<transition name="fade">
							<div style="clear: both;">
								<base-reg-size-form
									v-if="showRegSizeForm"
									class="mb-2"
									:options="sizeOptions"
									:show-title="false"
									:show-sub-title="false"
									:postcode="postcode"
								></base-reg-size-form>
							</div>
						</transition>
					</div>
				</div>
				<div class="col-12 col-md-8  mb-2 mb-sm-4">
					<div class="rounded-lg border-thin p-3">
						<h2 class="h3 text-start fs-5">Select your tyre size</h2>
						<confirm-size-tyre-options :option="car.options" :option-type="car.options[0].back"></confirm-size-tyre-options>
						<confirm-size-labels :options="car.options"></confirm-size-labels>
						<confirm-size-options :options="car.options" :errors="errors"></confirm-size-options>
						<p class="text-underline cursor-pointer" @click="toggleRegSizeForm()">Not your tyre size? Click here to enter the correct size</p>
						<div class="col-12 my-2">
							<div class="check-your-tyres-disclaimer alert bg-notify p-2 text-center w-100">
								Check your tyres to ensure you add the right tyre sizes to your order. <b><a :href="this.baseUrl + '/calculate-your-tyre-size'" target="_blank" title="Check your tyres">Here's how...</a></b>
							</div>
						</div>
						<div class="col-12 text-center mb-2">
							<Field v-if="brand" name="brand" type="hidden" :value="brand" />
							<button type="submit" class="btn btn-primary w-auto fs-6 py-2 px-md-5 mb-2 d-block ms-auto">
								Continue to select tyres
							</button>
						</div>
					</div>
				</div>
			</form>
		</VeeForm>
	</div>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage } from 'vee-validate';
    import * as yup from 'yup';

    export default {
	    props: [
			'car',
			'runFlatCheckMakes',
			'runFlatLanding',
			'runFlat',
			'electricHybrid',
			'sizeOptions',
			'postcode',
			'brand'
		],
	    components: { VeeForm, Field, ErrorMessage},
	    data() {
			const confirmValidationSchema = yup.object({
	            size: yup.string().required('Please select a tyre size to proceed.')
	        });

	        return {
	            tyrePosition: 'same',
	            vehicle_type: '',
				confirmValidationSchema,
				showRegSizeForm: false
	        }
	    },
	    mounted() {
			let vm = this;
            this.emitter.on('updateTyrePosition', function(value) {
                vm.tyrePosition = value;
            });
	    },
	    methods: {
			toggleRegSizeForm() {
				this.showRegSizeForm = !this.showRegSizeForm;

				if(this.showRegSizeForm == true) {
					document.getElementById('regSizeFormAnchor').scrollIntoView({ behavior: 'smooth' });
				}
			},
			async onSizeSubmit(values) {
				this.emitter.emit('isLoading', true);

				var formData = new FormData();
                formData.append('run_flat', values.run_flat);
                formData.append('size', values.size);
				formData.append('tyre_position', this.tyrePosition);
				formData.append('brand', values.brand);
				formData.append('jsonOnly', true);

				var response = await axios.post('/enter-size-submit', formData);

				if(response.status == 200 && response.data != '') {
					window.location.href = this.baseUrl + '/' + response.data;
				}
				else {
					this.emitter.emit('isLoading', false);
				}
			}
	    },
	    computed: {

	    }
	}
</script>
<style lang="scss">
	.confirm-size-wrapper {
		.confirm-size-form {
			.reg-input {
				padding: 5px 10px;
				border-radius: 6px;
				background: #fc3 !important;
				background-color: #fc3 !important;
				text-align: center;
				color: #212121;
				font-size: 18px;
				text-transform: uppercase;
				margin-bottom: 10px;
				display: inline-block;
				width: auto;
			}
			ul {
				list-style-type: none;
			}
			.title {
				font-size: 16px;
				margin: 15px 0 5px;
			}
			.how-to-check-run-flat {
				font-size: 16px;
				display: inline-block;
			}
			.tyre-size-label {
				font-size: 20px
			}
			.reg-size-form {
				box-shadow: none;
				width: 100%;
			}
		}
		.run-flat-check {
			border: solid #ddd 1px;
			padding: 10px;
			border-radius: 5px;
			text-align: left;
			b {
				font-size: 18px;
			}
			label {
				padding: 2px 15px;
				width: auto;
			}
			img {
				height: 123px;
				width: 123px;
			}
		}
		.divider {
			height: 2px !important;
			width: 100%;
			@media screen and (min-width: 768px) {
				height: 95% !important;
				width: 2px;
			}
			margin: 10px auto;
			background-color: #D3D3D3;
		}
		.fade-enter-active,
		.fade-leave-active {
			transition: opacity 0.5s ease;
		}

		.fade-enter-from,
		.fade-leave-to {
			opacity: 0;
		}
	}

</style>